/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbAuthResult } from '@nebular/auth';
import { NbAuthService } from '@nebular/auth/services/auth.service';
import { UserService } from '../../../../@core/data/user.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { ProjectsService } from '../../../../@core/data/projects.service';


@Component({
  selector: 'ngx-logout',
  template: `
    <div class="text-center title mb-5">
      <img class="img-fluid" src={{logo}} alt="Logo">
    </div>
    <h3 class="text-center">Estás saliendo del sistema, espera...</h3>
  `,
})
export class NgxLogoutComponent implements OnInit {

  logo: string;

  redirectDelay = 150;

  constructor(
    protected service: NbAuthService,
    protected router: Router,
    private userService: UserService,
    private http: HttpClient,
    private projectsService: ProjectsService,
  ) {
    try {
      const headers: HttpHeaders = new HttpHeaders({
        'Content-Type': 'application/json',
      });
      const options =  {headers: headers};
      this.http
        .get('https://server.sinecta.com/api/v1/domains', options)
        .subscribe(
          (result: any) => {
            const full = window.location.host;
            const parts = full.split('.');
            const sub = parts[0];
            const domain = parts[1];
            if (sub === 'app' && domain === 'sinecta') { // app.sinecta.com
              return this.logo = '/assets/images/logoseguros-app.jpg';
            }
  
            if (sub.includes('localhost') || sub.includes('159')) { // localhost:4200
              return this.logo = '/assets/images/clientes/Sinecta_Logotipo-2-03.png';
            }
  
            if (sub === 'clientes' && domain === 'sinecta') {
              return this.logo = '/assets/images/clientes/Sinecta_Logotipo-2-03.png';
            }
          });
    } catch (error) {
      console.log(error);
    }
  }



  ngOnInit(): void {
    setTimeout(() => {
    this.userService.logout()
    .then(response => {
      if (response) {
        this.logout('email');
        localStorage.clear();
        sessionStorage.clear();
      } else {
        throw new Error('Something went terribly wrong');
      }
    }).catch((error) => {console.log('logout =>',error);});
  }, this.redirectDelay);
  }

  clearLocalStorage() {
    localStorage.removeItem('map');
    localStorage.removeItem('searchMap');
    localStorage.removeItem('projects');
    localStorage.removeItem('search');
    localStorage.removeItem('searchTags');
    localStorage.removeItem('sort');
    localStorage.removeItem('sortDirection');
    localStorage.removeItem('pageIndex');
    localStorage.removeItem('tab_actual');
    localStorage.removeItem('orderName');
    localStorage.removeItem('orderBy');
  }

  logout(provider: string): void {
    try {
      this.projectsService.clearProjects();
      this.service.logout(provider).subscribe((result: NbAuthResult) => {
        this.clearLocalStorage();
        const redirect = result.getRedirect();
        if (redirect) {
          setTimeout(() => {
            return this.router.navigateByUrl(redirect);
          }, this.redirectDelay);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
}
